import { fetchHil2, getDiff } from "@/utils";
import * as _ from "lodash";

export function createSyncHandler(urlBuilder, updateMethod, ignoreFields) {
  return async ({ commit, state }) => {
    const orig = state.previous;
    const updatable = _.omit(state.current, ignoreFields);
    const origCurrent = _.cloneDeep(state.current);
    const diff = getDiff(orig, updatable);
    if (Object.keys(diff).length > 0) {
      const url = urlBuilder(state);
      const resp = await fetchHil2("put", url, {
        body: { ...diff }
      });

      if (
        "statusCode" in resp &&
        !(resp.statusCode >= 200 && resp.statusCode < 300)
      ) {
        throw new Error(resp.message);
      }

      // Verify the state didn't change since the http query was made
      if (!getDiff(origCurrent, state.current, true)) {
        commit(updateMethod, { resp, updatedKeys: diff });
      }
    }
  };
}
